import React from 'react';
import { Trans } from 'react-i18next';

import BasePage from 'components/utils/BasePage';

import { HELP } from 'constants/UrlConstants';

import { getLangCountryPrefix } from '../helpers/utils';
import { useApp, useLanguage } from '../hooks/selectors';
import { PromoInfoPage } from './no-auth/common/PromoInfoPage/PromoInfoPage';

const NotFound = () => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const helpLink = `${getLangCountryPrefix(lang, country)}${HELP}`;

    return (
        <PromoInfoPage
            animatedIconFail
            headerText={<Trans>ps.404.header.text</Trans>}
            secondaryText={<Trans>ps.404.error.description</Trans>}
            buttonRowType="link"
            buttonRowCaption={<Trans>ps.404.help</Trans>}
            buttonRowHref={helpLink}
        />
    );
};

export default BasePage(NotFound, '/');
